import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
export class Sucursal{
  public sucursalid?: number;
  public institutionid: number;
  public sucursales?: any;
  public codigo?: string;
  public nombre?: string;
}
@Injectable({
  providedIn: 'root'
})
export class SucursalService {
  private readonly apiURL = environment.api_proyecciones;
  private headers = new HttpHeaders().append('Content-Type', 'application/json');
  constructor(
    private http: HttpClient,
  ) { }
  public postSucursal(suc): Observable<any>{
    const sucursal: Sucursal = {
      institutionid: suc.institutionid,
      sucursales: suc.sucursales
    }
    const body = JSON.stringify(sucursal);
    const apiURL = this.apiURL + 'api/Createsucursal';
    return this.http.post(apiURL, body, { headers: this.headers});
  }

  public getSucursales(instId): Observable<any>{
    const inst = {
      institutionid: instId, 
    }
    const body = JSON.stringify(inst);
    const apiURL = this.apiURL + 'api/Listsucursal';
    return this.http.post(apiURL, body, { headers: this.headers});
  }

  public patchSucursal(suc, id): Observable<any>{
    const sucursal: Sucursal ={
      sucursalid: id,
      institutionid: suc.institutionid,
      codigo: suc.codigo,
      nombre: suc.nombre,
    }
    const body = JSON.stringify(sucursal);
    const apiURL = this.apiURL + 'api/Updatesucursal';
    return this.http.post(apiURL, body, { headers: this.headers});
  }
}
